export default "<app-header></app-header>\r\n<app-contact-register></app-contact-register>\r\n<app-contact-location></app-contact-location>";